import { getAuthHeaders } from "@/lib/auth-fetch";
import { API_BASE } from "@/lib/utils";

async function ntFetch(path, options = {}) {
  const res = await fetch(`${API_BASE}/api${path}`, {
    ...options,
    headers: {
      "content-type": "application/json",
      ...getAuthHeaders(),
      ...(options.headers || {}),
    },
    credentials: "same-origin",
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(body?.detail || `Request failed (${res.status})`);
  }
  return body;
}

export function fetchNotificationMeta() {
  return ntFetch("/admin/notification-templates/meta");
}

export function fetchNotificationTemplates(group, locale = "en") {
  const params = new URLSearchParams({ locale });
  if (group) params.set("group", group);
  return ntFetch(`/admin/notification-templates?${params.toString()}`);
}

export function fetchNotificationTemplate(triggerId, locale = "en") {
  return ntFetch(`/admin/notification-templates/${encodeURIComponent(triggerId)}?locale=${encodeURIComponent(locale)}`);
}

export function updateNotificationTemplate(triggerId, patch, locale = "en") {
  return ntFetch(`/admin/notification-templates/${encodeURIComponent(triggerId)}?locale=${encodeURIComponent(locale)}`, {
    method: "PUT",
    body: JSON.stringify(patch),
  });
}

export function resetNotificationTemplateOverride(triggerId, locale = "en") {
  return ntFetch(`/admin/notification-templates/${encodeURIComponent(triggerId)}/override?locale=${encodeURIComponent(locale)}`, {
    method: "DELETE",
  });
}

export function previewNotificationTemplate(triggerId, payload) {
  return ntFetch(`/admin/notification-templates/${encodeURIComponent(triggerId)}/preview`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function testNotificationTemplate(triggerId, payload) {
  return ntFetch(`/admin/notification-templates/${encodeURIComponent(triggerId)}/test`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function improveNotificationCopy(body, tone = "helpful") {
  return ntFetch("/admin/notification-templates/improve-copy", {
    method: "POST",
    body: JSON.stringify({ body, tone }),
  });
}

export function fetchTemplateVersion(versionId) {
  return ntFetch(`/admin/notification-templates/versions/${encodeURIComponent(versionId)}`);
}
